<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
            <div class="md:flex md:items-center md:justify-between">
                <div class="flex-1 min-w-0">
                    <h1 class="py-0.5 text-2xl font-semibold text-gray-900">{{ $t('Logs') }}</h1>
                </div>
            </div>
        </div>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="my-6 bg-white shadow overflow-hidden sm:rounded-md">
                <loading :status="loading"/>
                <template v-if="logList.length > 0">
                    <ul>
                        <template v-for="(log, index) in logList">
                            <li v-if="readable.includes(log.extension.toLowerCase())" :class="{'border-t border-gray-200': index !== 0}">
                                <router-link
                                    :to="'/dashboard/admin/logs/' + log.file"
                                    class="block hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                                >
                                    <div class="flex items-center px-4 py-4 sm:px-6">
                                        <div class="min-w-0 flex-1 flex items-center truncate">
                                            <div class="flex gap-3 truncate">
                                                <div class="flex-shrink-0 inline-block align-middle font-medium leading-5 text-green-700">{{ "." + log.extension.toUpperCase() }}</div>
                                                <div class="flex-shrink-0 inline-block align-middle text-sm font-medium leading-5 text-gray-900">{{ log.name.charAt(0).toUpperCase() + log.name.slice(1) }}</div>
                                                <div class="flex items-center text-sm leading-5 text-gray-500 truncate">
                                                    <svg-vue class="flex-shrink-0 mr-1.5 h-3 w-3 text-gray-500" icon="font-awesome.fingerprint-solid"></svg-vue>
                                                    <span class="truncate">{{ log.size | prettyBytes }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <svg-vue class="h-5 w-5 text-gray-400" icon="font-awesome.angle-right-regular"></svg-vue>
                                        </div>
                                    </div>
                                </router-link>
                            </li>
                            <li v-else :class="{'border-t border-gray-200': index !== 0}">
                                <div class="block hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out cursor-not-allowed">
                                    <div class="flex items-center px-4 py-4 sm:px-6">
                                        <div class="min-w-0 flex-1 flex items-center truncate">
                                            <div class="flex gap-3 truncate">
                                                <div class="flex-shrink-0 inline-block align-middle font-medium leading-5 text-green-700">{{ "." + log.extension.toUpperCase() }}</div>
                                                <div class="flex-shrink-0 inline-block align-middle text-sm font-medium leading-5 text-gray-900">{{ log.name.charAt(0).toUpperCase() + log.name.slice(1) }}</div>
                                                <div class="flex items-center text-sm leading-5 text-gray-500 truncate">
                                                    <svg-vue class="flex-shrink-0 mr-1.5 h-3 w-3 text-gray-500" icon="font-awesome.fingerprint-solid"></svg-vue>
                                                    <span class="truncate">{{ log.size | prettyBytes }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <svg-vue class="h-5 w-5 text-red-300" icon="font-awesome.times-light"></svg-vue>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </template>
                    </ul>
                </template>
                <template v-else-if="!loading">
                    <div class="h-full flex">
                        <div class="m-auto">
                            <div class="grid grid-cols-1 justify-items-center h-full w-full px-4 py-10">
                                <div class="flex justify-center items-center">
                                    <svg-vue class="h-full h-auto w-64 mb-12" icon="undraw.browsing"></svg-vue>
                                </div>
                                <div class="flex justify-center items-center">
                                    <div class="w-full font-semibold text-2xl">{{ $t('No records found') }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: "list",
    metaInfo() {
        return {
            title: this.$i18n.t('Logs')
        }
    },
    data() {
        return {
            loading: true,
            logList: [],
            readable: ['log', 'txt']
        }
    },
    mounted() {
        this.getLogs();
    },
    methods: {
        getLogs() {
            const self = this;
            self.loading = true;
            axios.get('api/dashboard/admin/logs').then(function (response) {
                self.logList = response.data.logs;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        }
    }
}
</script>
